/**
 * Converts pixel values to rem units based on a given base font size.
 * 
 * @param {number|string} px - The pixel value to convert. Can be a number or string with or without 'px' suffix.
 * @param {number} [base=16] - The base font size in pixels (typically the root font size). Defaults to 16px.
 * @returns {string} The converted value as a string with 'rem' suffix.
 * 
 * @example
 * // Convert 24px to rem using default base (16px)
 * remCalc(24) // returns '1.5rem'
 * 
 * @example
 * // Convert with string input including 'px'
 * remCalc('32px') // returns '2rem'
 * 
 * @example
 * // Convert multiple values at once (px is optional for each part)
 * remCalc('32px 16') // returns '2rem 1rem'
 *
 * @example
 * // Convert negative values
 * remCalc('-32px 16px 8px 8px') // returns '-2rem 1rem .5rem .5rem'
 *
 * @example
 * // Convert non-whole numbers
 * remCalc(16.5) // returns '1.03125rem'
 *
 * @example
 * // Convert using custom base font size
 * remCalc(20, 10) // returns '2rem'
 */
export const remCalc = (px, base = 16) => {
	const tempPx = `${px}`.replace(/px/ig, '');
	const parts = tempPx.split(/[\s|,]/).filter(item => item);
	const rems = [];
	for (const part of parts) {
		rems.push(`${(1 / base) * parseFloat(part)}rem`);
	}
	return rems.join(' ');
}
